var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"limit-notification-fade"}},[(_setup.isShow)?_c('div',{staticClass:"limit-notification"},[_c('span',{staticClass:"limit-notification__text"},[_vm._v(_vm._s(_setup.text))]),_c('span',{staticClass:"limit-notification__close",on:{"click":_setup.hide}},[_c(_setup.SvgClose)],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }